module.exports = __webpack_public_path__ + "static/img/app08.b9c43de.png";


//////////////////
// WEBPACK FOOTER
// ./static/appPic/app08.png
// module id = QxvY
// module chunks = 1